import 'src/components/HStack/HStack.css.ts.vanilla.css?source=Ll8xN2lyZWV3MSB7CiAgZGlzcGxheTogZ3JpZDsKICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHZhcigtLV8xN2lyZWV3MCk7Cn0=';
export var gridCols = 'var(--_17ireew0)';
export var stack = '_17ireew1';